/** Resolve staff name / assignment for Jobs → Shifts list rows. */

import { isSubmittedActualState } from "./shiftActualState";

function trimName(value) {
  const s = String(value ?? "").trim();
  if (!s || s.toLowerCase() === "unassigned") return "";
  return s;
}

function nameFromParts(shift) {
  const first = trimName(
    shift?.assigned_staff_first ??
      shift?.staff_first_name ??
      shift?.first_name ??
      "",
  );
  const last = trimName(
    shift?.assigned_staff_last ??
      shift?.staff_last_name ??
      shift?.last_name ??
      "",
  );
  if (first || last) return `${first} ${last}`.trim();
  return "";
}

/**
 * Display name for the Staff column (list + detail parity).
 */
export function resolveShiftStaffDisplayName(shift) {
  if (!shift || typeof shift !== "object") return "Unassigned";

  const direct = [
    shift.staffDisplay,
    shift.staff,
    shift.assigned_staff,
    shift.assigned_staff_name,
    shift.staff_name,
    shift.staffDisplayName,
  ];

  for (const raw of direct) {
    const name = trimName(raw);
    if (name) return name;
  }

  const fromParts = nameFromParts(shift);
  if (fromParts) return fromParts;

  const acc = shift.account;
  if (acc && typeof acc === "object") {
    const accName = trimName(
      acc.name ||
        [acc.first_name, acc.last_name].filter(Boolean).join(" "),
    );
    if (accName) return accName;
  }

  return "Unassigned";
}

export function resolveShiftStaffAccountId(shift) {
  const id = Number(
    shift?.assigned_staff_id ??
      shift?.staff_id ??
      shift?.accountId ??
      shift?.account_id ??
      shift?.personnel_account_id ??
      0,
  );
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function resolveOutsourcedPayerId(shift) {
  const id = Number(
    shift?.outsourcedPayerId ?? shift?.outsourced_payer_id ?? 0,
  );
  return Number.isFinite(id) && id > 0 ? id : null;
}

/** True when shift has a real assignee (legacy row.accountId || outsourcedPayerId). */
export function shiftHasRealStaff(shift) {
  return !!(resolveShiftStaffAccountId(shift) || resolveOutsourcedPayerId(shift));
}

/** Legacy actual-time-submission isUnassigned — unassigned slot with no actual submit yet. */
export function isActualColumnUnassigned(shift, actualStateRaw) {
  const shiftState = String(shift?.shiftState ?? shift?.state ?? "")
    .replace(/[\s_]+/g, "")
    .toLowerCase();
  const notSubmitted = !isSubmittedActualState(actualStateRaw);
  return notSubmitted && shiftState === "unassigned";
}
